var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{tag:"component",class:[
        'a-filters-toggle group',
        _vm.isFiltersOpen && _vm.checkBreakpointDownXl ? 'hidden' : '' ],on:{"click":_vm.handleToggle}},[_c('div',{staticClass:"cursor-pointer relative"},[_c('div',{class:[
                'border-1 border-secondary bg-white flex h-12',
                'items-center justify-center rounded-full w-12',
                '2xl:justify-between 2xl:w-[calc(3.5rem_+_52px)] 2xl:px-4',
                '2xl:transition',
                _vm.isFiltersOpen ? '2xl:border-primary' : '' ]},[_c('div',{staticClass:"flex flex-col h-3 items-center justify-between relative w-3"},[_c('div',{staticClass:"relative"},[_c('div',{class:[
                            'border-t-1 border-t-secondary h-0 w-4 origin-right 2xl:transition 2xl:duration-300',
                            _vm.isFiltersOpen === true
                                ? 'border-t-primary rotate-45 translate-x-[-1px] translate-y-[13px]'
                                : '' ]}),_vm._v(" "),_c('div',{class:[
                            'absolute right-0 top-1/2 -translate-y-1/2 duration-300 transition',
                            'bg-white border-secondary border-2 h-2 rounded-full w-2',
                            'group-hover:-translate-x-full',
                            _vm.isFiltersOpen === true
                                ? 'opacity-0 pointer-events-none'
                                : '' ]})]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('div',{class:[
                            'border-t-1 border-t-secondary h-0 w-4 origin-left 2xl:transition 2xl:duration-300',
                            _vm.isFiltersOpen === true
                                ? 'border-t-primary -rotate-45 translate-x-[4px] translate-y-[2px]'
                                : '' ]}),_vm._v(" "),_c('div',{class:[
                            'absolute left-0 top-1/2 -translate-y-1/2 duration-300 transition',
                            'bg-white border-secondary border-2 h-2 rounded-full w-2',
                            'group-hover:translate-x-full',
                            _vm.isFiltersOpen === true
                                ? 'opacity-0 pointer-events-none'
                                : '' ]})])]),_vm._v(" "),_c('div',{staticClass:"hidden w-[52px] text-right h-full 2xl:block 2xl:overflow-hidden 2xl:relative"},[_c('span',{class:[
                        'absolute block left-0 text-base text-secondary top-1/2 transition w-[52px]',
                        _vm.isFiltersOpen
                            ? 'opacity-0 pointer-events-none -translate-y-full'
                            : 'opacity-1 -translate-y-1/2' ]},[_vm._v(_vm._s(_vm.$t("Filtri")))]),_vm._v(" "),_c('span',{class:[
                        'absolute block left-0 text-base text-primary top-1/2 transition w-[52px]',
                        _vm.isFiltersOpen
                            ? 'opacity-1 -translate-y-1/2'
                            : 'opacity-0 pointer-events-none translate-y-full' ]},[_vm._v(_vm._s(_vm.$t("Chiudi")))])])]),_vm._v(" "),(
                _vm.isFiltersOpen === false &&
                    _vm.activeFilters &&
                    _vm.activeFilters > 0
            )?_c('div',{class:[
                'absolute right-0 top-0 translate-x-1/4 -translate-y-1/4',
                'border-1 border-secondary font-bold text-sm',
                'bg-white flex h-[22px] items-center justify-center rounded-full',
                'text-secondary w-[22px]' ]},[_vm._v("\n            "+_vm._s(String(_vm.activeFilters).trim())+"\n        ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }